import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Checkbox, Button } from '@mui/material';
import { useStateContext } from '../contexts/ContextProvider'
import styled from '@emotion/styled'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const Container = styled(Paper)({

    display: 'flex',
    flexDirection: 'column',
    padding: '15px',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
    borderRadius: '10px',
    width: '90%',  
    height: '70%',
    marginTop: '1%'
})

function MultiManageSelector() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { manageData, setManageData, manageFilter, setManagePaneVisible, setToEditId, setLastMethod} = useStateContext();

    const handleAddClick = () => {
        const existingIds = manageData.map(item => item.id);
        let newId;
        do {
            newId = Math.floor(Math.random() * 1000000);
        } while (existingIds.includes(newId));
        const id = newId;
        setManageData([{id:id, name:'', uen_number:'', company: '', email:'', business_matching_meeting: '', mobile:'', remarks:'',}, ...manageData])
        setToEditId(id)
        setManagePaneVisible(true);
        setLastMethod('Add');
    }

    const filteredData = manageData.filter(item =>
        (!manageFilter.name || item.name.toLowerCase().includes(manageFilter.name.toLowerCase())) &&
        (!manageFilter.uen_number || item.uen_number.toLowerCase().includes(manageFilter.uen_number.toLowerCase())) &&
        (!manageFilter.company || item.company.toLowerCase().includes(manageFilter.company.toLowerCase())) &&
        (!manageFilter.mobile || item.mobile.toLowerCase().includes(manageFilter.mobile.toLowerCase()))
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const toggleSelect = (index) => {
        const updatedData = manageData.map((item, i) => {
            if(index === i) {
                return ({...item, check_in: item.check_in === "Yes" ? "No" : "Yes"})
            }
            else {
                return item
            }
        });
        setManageData(updatedData);
    };

    const handleEdit = (index) => {
        setManagePaneVisible(true);
        setToEditId(index); 
        setLastMethod("Edit");
    }

    const handleDelete = (index) => {
        setManageData(manageData.filter(item => item.id !== index))
    }

    return (
        <Container>
            <TableContainer component={Paper} style={{ height: '400px' }}>
            <Table stickyHeader>
                <TableHead>
                <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>UEN Number</TableCell>
                    <TableCell>Company</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Business Match Meeting</TableCell>
                    <TableCell>Mobile</TableCell>
                    <TableCell>Remarks</TableCell>
                    <TableCell>Check_in</TableCell>
                    <TableCell style={{ paddingLeft: "3%"}}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ margin: '0 8px' }}
                        onClick={handleAddClick}
                    >
                        Add
                    </Button>
                    </TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                    {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                    <TableRow key={index} style={{position: "relative"}}>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.uen_number}</TableCell>
                        <TableCell>{row.company}</TableCell>
                        <TableCell>{row.email}</TableCell>
                        <TableCell>{row.business_matching_meeting}</TableCell>
                        <TableCell>{row.mobile}</TableCell>
                        <TableCell>{row.remarks}</TableCell>
                        <TableCell>
                            <Checkbox
                                checked={row.check_in === "Yes" ? true : false}
                                onChange={() => toggleSelect(page * rowsPerPage + index)}
                            />
                        </TableCell>
                        <TableCell>
                            <Button onClick={() => handleEdit(row.id)}>
                                Edit
                            </Button>
                            <Button style={{"color":"#F31559"}} onClick={() => handleDelete(row.id)}>
                                Delete
                            </Button>
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
            </TableContainer>
            <div style={{display:"flex",flexDirection:"row", justifyContent:"space-between"}}>
                <div style={{marginTop:"15px", display:"flex", flexDirection:"row"}}>
                    <div style={{marginRight:"10px"}}>
                    Check in: {manageData.filter(item => item.check_in === "Yes").length}
                    </div>
                    <div style={{marginRight:"10px"}}>
                    Business match meeting: {manageData.filter(item => item.business_matching_meeting.length).length}
                    </div>
                </div>
            <TablePagination
                style={{ overflow: 'hidden' }} 
                rowsPerPageOptions={[10, 20, 40]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </div>
        </Container>
    );
}

export default MultiManageSelector;